import { Config } from './config'
import { fetchUnreadOfferNotificationsCount as defaultFetchUnreadOfferNotificationsCount } from './fetch'
import { ShopMessageBus } from './messages/ShopMessageBus'
import { preResolveConfig as defaultPreResolveConfig } from './preFetch'
import { ICXF } from './types/cxf'
import { IShopMessageBus } from './types/models'
import { entityProvider, IProvider, IStore } from './types/store'

class GlobalState {
    public config: Config | undefined = undefined
    public cxfProvider: IProvider<ICXF> = entityProvider()
    public dialogProvider: IProvider<HTMLElement> = entityProvider()
    public storeProvider: IProvider<IStore> = entityProvider()
    public shopMessageBus: IShopMessageBus = new ShopMessageBus()
    public fetchUnreadOfferNotificationsCount: () => Promise<void> | void = defaultFetchUnreadOfferNotificationsCount
    public preResolveConfig: () => void = defaultPreResolveConfig

    public setConfig(config: Config): void {
        this.config = config
    }

    public getConfig(): Config {
        if (this.config === undefined) {
            throw new Error('Config is not initialized')
        }
        return this.config
    }

    public setCxf(cxf: ICXF): void {
        this.cxfProvider.set(cxf)
    }

    public getCxf(): ICXF {
        const cxf = this.cxfProvider.get()
        if (!cxf) {
            throw new Error('CXF is not loaded')
        }
        return cxf
    }

    public setStore(store: IStore): void {
        this.storeProvider.set(store)
    }

    public getStore(): IStore {
        const store = this.storeProvider.get()
        if (!store) {
            throw new Error('Store is not initialized')
        }
        return store
    }

    public updateStore(data: Partial<IStore>): void {
        const currentStore = this.getStore()
        this.setStore({
            ...currentStore,
            ...data,
        })
    }
}

export const globalState = new GlobalState()
